<template>
  <span>
    <template v-if="type === 'batch'">
      <a-dropdown :disabled="disabled || showOptions.length === 0">
        <template #overlay>
          <a-menu @click="operation">
            <template v-for="option in showOptions"><a-menu-item :key="option.key">{{ option.name }}</a-menu-item></template>
          </a-menu>
        </template>
        <a-button type="primary" :disabled="disabled || showOptions.length === 0">{{ $t('通用_批量操作') }}<a-icon type="down"/></a-button>
      </a-dropdown>
    </template>
    <template v-else>
      <a-space>
        <template v-for="option in showOptions">
          <dol-button :title="option.name" @click="operation(option)"><a-icon :type="option.icon"/></dol-button>
        </template>
      </a-space>
    </template>


    <pickup-record-modal @refresh="refresh" ref="pickupRecordModal"/>
    <transport-info-modal @refresh="refresh" ref="transportInfoModal"/>
    <apply-return-modal @refresh="refresh" ref="applyReturnModal"/>
    <confirm-return-modal @refresh="refresh" ref="confirmReturnModal"/>

    <!-- 异常流程操作 -->
    <withdraw-apply-order-modal @refresh="refresh" ref="withdrawApplyOrderModal"/>
    <apply-order-cancel-modal @refresh="refresh" ref="applyOrderCancelModal"/>
    <apply-release-order-delay-modal @refresh="refresh" ref="applyReleaseOrderDelayModal"/>
  </span>
</template>

<script>
import pickupRecordModal from '@/views/order/orderListComponents/pickup-record-modal.vue';
import transportInfoModal from '@/views/order/orderListComponents/transport-info-modal.vue';
import applyReturnModal from '@/views/order/orderListComponents/apply-return-modal.vue';
import confirmReturnModal from '@/views/order/orderListComponents/confirm-return-modal.vue';
import applyOrderCancelModal from '@/views/order/orderListComponents/apply-order-cancel-modal.vue';
import applyReleaseOrderDelayModal from '@/views/order/orderListComponents/apply-release-order-delay-modal.vue';
import { mapState } from 'vuex';
import WithdrawApplyOrderModal from '@/views/order/orderListComponents/withdraw-apply-order-modal.vue';

export default {
  name: 'cargo-box-line-operation',
  components: {
    WithdrawApplyOrderModal,
    pickupRecordModal,
    applyReturnModal,
    transportInfoModal,
    confirmReturnModal,
    applyOrderCancelModal,
    applyReleaseOrderDelayModal,
  },
  props: {
    type: { type: String, default: 'batch' }, // 操作方式，batch | single
    disabled: { type: Boolean },
    boxList: { type: Array },
  },
  data () {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
    boxStatus () {
      if (this.boxList.length === 0) return null;
      return this.boxList[0].XBXC_BOX_STATUS;
    },
    orderStatus () {
      if (this.boxList.length === 0) return null;
      return this.boxList[0].XBXC_STATUS;
    },
    hasTransform () {
      if (this.boxList.length === 0) return true;
      if (this.boxStatus < 20441004) return true;
      return this.boxList.find(item => item.HAS_TRANSFORM);
    },
    showOptions () {
      const buttons = [];
      if (this.orderStatus === 20431001) {
        buttons.push({ name: this.$t('租赁_撤销申请'), key: 'withdrawApplyOrder', icon: 'rollback' });
      }
      if (this.orderStatus === 20431003 || this.orderStatus === 20431004 || this.orderStatus === 20431005) {
        buttons.push({ name: this.$t('租赁_申请订单作废'), key: 'applyCancelOrder', icon: 'delete' });
      }
      if (this.boxStatus === 20441003) {
        buttons.push({ name: this.$t('租賃_下载放箱单'), key: 'downloadReleaseOrderFile', icon: 'download' });
        if (this.type === 'single') {
          // buttons.push({name: this.$t('申请放箱单延期'), key: 'applyReleaseOrderDelay'});
        }
        buttons.push({ name: this.$t('租赁_录入提箱信息'), key: 'inputContainerInfo', icon: 'database' });
      }
      if (!this.hasTransform) {
        buttons.push({ name: this.$t('租赁_录入运输信息'), key: 'inputTransportInfo', icon: 'pic-center' });
      }
      if (this.boxStatus === 20441004) {
        buttons.push({ name: this.$t('租赁_申请还箱'), key: 'applyReturnContainer', icon: 'interaction' });
      }
      if (this.boxStatus === 20441006) {
        buttons.push({ name: this.$t('downloadTheReturnInstructions'), key: 'downloadReturnOrderFile', icon: 'file-done' });
        if (this.type === 'single') {
          // buttons.push({name: this.$t('申请还箱指令延期'), key: 'applyReturnOrderDelay'});
        }
        buttons.push({ name: this.$t('confirmReturnBox'), key: 'inputReturnInfo', icon: 'check' }); // 确认还箱
      }

      // 单行
      if (this.type === 'single') {
        buttons.push({ name: this.$t('租赁_再来一单'), key: 'quickNewOrder', icon: 'copy' });
      }

      return buttons;
    },
  },
  methods: {
    refresh () {
      this.$emit('refresh');
    },
    operation ({ key }) {
      if (this.boxList.length === 0) {
        this.$message.error(this.$t('提示_组件参数有误'));
        return true;
      }
      switch (key) {
        case 'withdrawApplyOrder':
          this.$refs.withdrawApplyOrderModal.open(this.boxList);
          break;
        case 'applyCancelOrder':
          this.$refs.applyOrderCancelModal.open(this.boxList);
          break;
        case 'downloadReleaseOrderFile':
          this.downloadXeFile();
          break;
        case 'applyReleaseOrderDelay':
          this.$refs.applyReleaseOrderDelayModal.open(this.boxList);
          break; // TODO 先做正向流程
        case 'inputContainerInfo':
          this.$refs.pickupRecordModal.open(this.boxList);
          break;
        case 'inputTransportInfo':
          this.$refs.transportInfoModal.open(this.boxList);
          break;
        case 'applyReturnContainer':
          this.$refs.applyReturnModal.open(this.boxList);
          break;
        case 'downloadReturnOrderFile':
          this.downloadXhFile();
          break;
        case 'inputReturnInfo':
          this.$refs.confirmReturnModal.open(this.boxList);
          break;
        case 'quickNewOrder':
          this.quickNewOrder();
          break;
      }
    },
    downloadXeFile () {
      const map = {};
      this.boxList.forEach(item => {
        if (item.XE_FILE && !map[item.XE_FILE]) {
          map[item.XE_FILE] = true;
          let fileName = this.$t('putBoxVoucher');
          if (item.CUST_CODE) {
            fileName += '-' + item.CUST_CODE;
          }
          if (item.SEND_CODE) {
            fileName += '-' + item.SEND_CODE;
          }
          fileName += '.' + item.XE_FILE.split('.').pop();
          this.$Dolphin.download(fileName, this.$Dolphin.path.filePath + item.XE_FILE);
        }
      });
    },
    downloadXhFile () {
      const map = {}, downloadList = [];
      this.boxList.forEach(item => {
        if (item.XH_FILE) {
          if (!map[item.XH_FILE]) {
            map[item.XH_FILE] = { boxCodeList: [] };
            let fileName = this.$t('returnBoxInstructions');
            if (item.CUST_CODE) {
              fileName += '-' + item.CUST_CODE;
            }
            map[item.XH_FILE].fileName = fileName;
            map[item.XH_FILE].suffix = '.' + item.XH_FILE.split('.').pop();
            map[item.XH_FILE].link = this.$Dolphin.path.filePath + item.XH_FILE;
            downloadList.push(map[item.XH_FILE]);
          }
          map[item.XH_FILE].boxCodeList.push(item.BOX_CODE);
        }
      });

      downloadList.forEach(downloadTask => {
        const fileName = downloadTask.fileName + '-' + downloadTask.boxCodeList.slice(0, 3).join('-') + downloadTask.suffix;
        this.$Dolphin.download(fileName, downloadTask.link);
      });
    },
    quickNewOrder () {
      const order = this.boxList[0];
      this.$h5Api({
        type: '4101',
        data: [{ TARGET_ID: this.userInfo.COMPANY_ID, CITY_ID: order.CITY_ID || '', D_CITY_ID: order.D_CITY_ID || '' }],
      }).then(() => {
        const params = {
          NATION_ID: order.NATION_ID,
          D_NATION_ID: order.D_NATION_ID,
          CITY_ID: Number(order.CITY_ID),
          D_CITY_ID: Number(order.D_CITY_ID),
          VALID_PRICE: order.VALID_PRICE,
          BOX_SIZE: Number(order.BOX_SIZE),
          BOX_STATE: Number(order.BOX_STATE),
          REAL_QTY: order.ROUTE_QTY,
          GOODS_TYPE: order.GOODS_TYPE,
          GOODS_NAME: order.GOODS_NAME,
          UNIT_WEIGHT: order.UNIT_WEIGHT,
          TRANS_WAY: String(order.TRANS_WAY),
          ESTIM_DATE: order.ESTIM_DATE,
          CUST_CODE: order.CUST_CODE,
          SHEET_SRC: 20391008, // 再来一单
        };
        this.$router.push({
          name: 'boxApplyForm',
          params,
        });
      });
    },
  },
};
</script>

<style lang="scss">

</style>